<template>
  <div class="work-wrapper">
    <div class="tabs-wrapper">
      <a-tabs
          class="tabs-wrapper-app"
          @tabClick="handleTabClick"
          @edit="handleTabEdit"
          :activeKey="activeKey"
          :hideAdd="true"
          size="small">
        <a-tab-pane key="WorkHomeIndex" :closable="false">
          <div slot="tab" class="ant-tabs-tab-icon">
            <img :src="require('@/assets/home/icon-applys-blue.svg')"/>
            应用中心
          </div>
        </a-tab-pane>
      </a-tabs>
      <a-tabs
          class="tabs-wrapper-tab"
          @tabClick="handleTabClick"
          @edit="handleTabEdit"
          :activeKey="activeKey"
          type="editable-card"
          :hideAdd="true"
          size="small">
        <template v-if="tabList">
          <a-tab-pane v-for="tab in tabList" :key="tab.key" :closable="true">
            <div slot="tab" class="ant-tabs-tab-icon">
              <img :src="filePreview(tab.icon)"/>{{ tab.name }}
            </div>
          </a-tab-pane>
        </template>
      </a-tabs>
    </div>
    <app-layout
        v-show="activeKey === iframe.key"
        v-for="iframe in iframeList"
        :key="iframe.key"
        :ref="iframe.key"
        :url="iframe.url"
        :code="iframe.code">
    </app-layout>
    <keep-alive>
      <router-view v-if="!$route.meta.url && isWork"/>
    </keep-alive>
  </div>
</template>
<script>
import {mapState} from "vuex";
import AppLayout from "@/layouts/AppLayout.vue";
import {getAppDetail} from "@/api/admin/app";
import {objToUrlParams} from "@/utils/util";

export default {
  name: "WorkView",
  components: {AppLayout},
  computed: {
    ...mapState({
      tabs: state => state.tabs.tabs,
      iframeList: state => state.tabs.iframeList,
    }),
    tabList() {
      return this.tabs.filter(tab => tab.key !== 'WorkHomeIndex')
    },
    activeKey() {
      if (this.$store.getters.currentTab) {
        return this.$store.getters.currentTab.key
      } else {
        return 'WorkHomeIndex'
      }
    },
    isWork() {
      return this.$route.name === 'WorkHomeIndex' || this.$route.meta.type === 'app'
    },
  },
  data() {
    return {}
  },
  methods: {
    handleTabEdit(key) {
      this.$store.dispatch('DeleteTab', key).then(() => {
        const filterTabs = this.tabs.filter(tab => tab.key !== key);
        if (this.$store.getters.currentTab.key === key) {
          this.$router.push({name: filterTabs[filterTabs.length -1].code})
        } else if (this.$store.getters.currentTab.key === 'WorkHomeIndex') {
          this.$router.push({name: 'WorkHomeIndex'})
        }
      })
    },
    handleTabClick(key) {
      console.log('handleTabClick', key)
      const filterTab = this.tabs.find(tab => tab.key === key);
      console.log('currentCode', filterTab)
      this.$store.dispatch('ActiveTab', key).then(() => {
        console.log(filterTab.code, filterTab.key, filterTab.code === filterTab.key)
        if(filterTab.code === filterTab.key){
          this.$router.push({name: filterTab.code})
        }else{
          this.$router.push({name: filterTab.code, query: {tabKey: key}})
        }
        // this.$router.push({name: key})
        // console.log(key.substr(0,key.indexOf('_')), 111111111111111111)
        // if(key.indexOf('_') > -1){
        //   this.$router.push({name: key.substr(0, key.indexOf('_'))})
        // }else{
        //   this.$router.push({name: key})
        // }
      })
    },
    handleMessage(event) {
      // console.log('handleMessage', event)
      switch (event.data.type) {
        case 'openApp':
          this.openApp(event.data.data)
          break
        case 'hideHeader': {
          const ref = this.$refs[event.data.data && event.data.data.key]
          if (ref) {
            ref.showHeader = false
          }
          break
        }
        case 'showHeader': {
          const ref = this.$refs[event.data.data && event.data.data.key]
          if (ref) {
            ref.showHeader = true
          }
          break
        }
      }
    },
    openApp(data) {
      console.log('openApp', data)
      getAppDetail({appCode: data.appCode}).then(res => {
        if (res.success) {
          const url = new URL(res.data.pcUrl)
          let path = url.origin + (data.path ? data.path : url.pathname)
          if (data.param) {
            const paramStr = typeof data.param === 'object' ? objToUrlParams(data.param) : data.param
            if (path.indexOf('?') > -1) {
              path = path + '&' + paramStr
            } else {
              path = path + '?' + paramStr
            }
          }
          const appData = {
            name: data.name ? data.name : res.data.name,
            code: res.data.code,
            icon: res.data.icon,
            url: path,
            key: data.path ? `${res.data.code}_${Date.now()}` : res.data.code
          }

          this.routes = this.$router.getRoutes()
          const currentCode = this.routes.filter(item => item.name === appData.code)
          if (currentCode.length > 0) {
            this.$store.dispatch('AddTab', appData).then(() => {
              this.$router.push({name: appData.code, query: {tabKey: appData.key}})
            })
          } else {
            this.$message.warn('当前暂无此应用，请联系管理员！')
          }
        }
      })
    }
  },
  created() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  }

}
</script>
<style scoped lang="less"> .work-wrapper {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  background: #f2f3f5;
  border-radius: 4px;
  width: 0;

  .tabs-wrapper {
    display: flex;
    width: 100%;
    height: 45px;
    background-color: #d8dfe6;
    padding: 10px 15px 0 15px;
    border-radius: 4px;

    .tabs-wrapper-app {
      width: 187px;
    }

    .tabs-wrapper-tab {
      flex: 1;
    }

    /deep/ .ant-tabs-bar {
      margin: 0;

      .ant-tabs-tab {
        width: 188px;
        height: 35px;
        line-height: 35px;
        border: 0;
        border-radius: 8px 8px 0 0;
        margin-right: 0px;
        padding: 0 20px 0 20px;
        background: none;
        position: relative;
        font-size: 13px;

        &:after {
          content: '';
          position: absolute;
          width: 1px;
          height: 20px;
          z-index: 9;
          right: 0px;
          top: 8px;
          background: #bfbfbf;
        }

        &.ant-tabs-tab-active {
          background: url("~@/assets/home/tab-bg.png");

          &:after {
            right: auto;
            left: -1px;
            background: #d8dfe6;
          }
        }

        .ant-tabs-tab-icon {
          color: #05051a;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 90%;

          img {
            height: 16px;
            margin-right: 5px;
            vertical-align: -3px;
            border-radius: 3px;
          }
        }

        .ant-tabs-close-x {
          float: right;
          margin-top: 12px;
          color: #787889;
        }

        &:first-child {
          .ant-tabs-tab-icon img {
            border-radius: 0;
          }
        }
      }

      .ant-tabs-tab-arrow-show {
        margin-top: -3px;
      }
    }
  }
}
</style>
